// store/openApiThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/api/api";

export const fetchProfile = createAsyncThunk(
  "profileApis/fetchProfile",
  async () => {
    const response = await api.get("/profile");
    return response.data.data;
  }
);

